import React from 'react';
import { Input, Button, PaperClip, TitleModalRight, Textarea, Select, Pagination } from 'components';
import { OrderService } from 'services';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants } from 'utils';
import { WhiteImage } from 'assets/img';
import { ArrowLeftWhite, CleanIcon } from 'assets/icons';
import moment from 'moment';

interface Props {
	onClose?: any;
	onConfirm?: any;
}

class ModalConfirm extends React.Component<Props> {

	render() {
		return (
			<div id="modal-confirm-order">
				<p>¿Está seguro de cambiar el estatus a entregado?</p>
				<div className="container-buttons">
					<button className="btn-cancel" onClick={ () => this.props.onClose() }>
						Cancelar
					</button>
					<button className="btn-submit" onClick={ () => this.props.onConfirm() }>
						Aceptar
					</button>
				</div>
			</div>
		)
	}
}

export default ModalConfirm;